import React from 'react';
import { Input, List, Checkbox } from 'antd';
import type { Coop } from '../offer/OfferRegistrationModal';

interface ShowingAgentsFilterProps {
  onChange: (arg0: Coop[]) => void;
  agents: Coop[];
  extraFilter?: (agent: Coop) => boolean;
}

const ShowingAgentsFilter: React.FunctionComponent<
  ShowingAgentsFilterProps
> = ({ onChange, agents, extraFilter = () => true }) => {
  const [query, setQuery] = React.useState('');

  const filterAgents = ({ name, org }: Coop): boolean => {
    if (!query) return true;
    const upperQuery = query.toUpperCase();
    const upperName = name.toUpperCase();
    const upperOrg = org?.toString().toUpperCase();
    return (
      upperName.search(upperQuery) !== -1 || upperOrg?.search(upperQuery) !== -1
    );
  };

  const checkAllProps = (filteredAgents: Coop[]): object => {
    const countAll = filteredAgents.length;
    let countTrue = 0;
    let countFalse = 0;

    filteredAgents.forEach(({ checked }) => {
      if (checked) {
        countTrue += 1;
      } else {
        countFalse += 1;
      }
    });

    return {
      checked: countFalse !== countAll,
      indeterminate: countTrue !== countAll && countFalse !== countAll,
    };
  };

  const onCheckAll = (checked: boolean): void => {
    const newAgents = agents.map(agent => ({ ...agent, checked }));
    onChange(newAgents);
  };

  const onCheckAgent = (checked: boolean, uid?: string): void => {
    const newAgents = agents.map(agent => {
      if (agent.uid === uid) {
        return { ...agent, checked };
      }
      return agent;
    });
    onChange(newAgents);
  };

  const filteredAgents = agents.filter(filterAgents).filter(extraFilter);

  return (
    <>
      <List
        className="showing-agents-filter"
        header={
          <>
            <Checkbox
              {...checkAllProps(filteredAgents)}
              onChange={e => onCheckAll(e.target.checked)}
            />
            <Input.Search
              className="showing-agents-filter-list-search"
              placeholder="Search Agents"
              value={query}
              onChange={e => setQuery(e.target.value)}
            />
          </>
        }
      >
        {filteredAgents.map(({ name, org, checked, uid }, i) => (
            <List.Item key={i} style={{ flexWrap: 'nowrap' }}>
              <Checkbox
                checked={checked}
                onChange={e => onCheckAgent(e.target.checked, uid)}
              />
              <span className="showing-agents-filter-list-name">{name}</span>
              <span className="showing-agents-filter-list-org">{org}</span>
            </List.Item>
          ))}
      </List>
    </>
  );
};

export default ShowingAgentsFilter;
